/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaPictureIcon16Solid = forwardRef('MediaPictureIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 4.5A3.5 3.5 0 0 1 4.5 1h7A3.5 3.5 0 0 1 15 4.5v7a3.5 3.5 0 0 1-3.5 3.5h-7A3.5 3.5 0 0 1 1 11.5v-7Zm6 1a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm2.549 3.153a.375.375 0 0 1 .522 0l2.137 2.07a.75.75 0 0 0 1.044-1.077l-2.138-2.07a1.875 1.875 0 0 0-2.609 0L3.978 11.96a.75.75 0 0 0 1.044 1.077l4.527-4.385Z" })));
});
